import * as Sentry from '@sentry/vue'
import settings from '@/settings'

export default {
  install(app, options) {
    if (import.meta.env.MODE !== 'production') return

    const router = options.router
    Sentry.init({
      app,
      dsn: settings.sentryDsn,
      integrations: [
        Sentry.browserTracingIntegration({ router: router }),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false
        })
      ],
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      tracingOptions: {
        trackComponents: true,
        hooks: ['activate', 'create', 'destroy', 'mount', 'update']
      },
      logErrors: true,
      attachProps: true,
      attachStacktrace: true
    })
  }
}
